<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer title="Edit Worksheet Type">
      <form v-on:submit.prevent="doSubmit">
        <label for="" class="mt-2 labels">Name *</label>
        <b-form-input type="text" class="mb-3" placeholder="Enter Name" v-model="model.name" name="name" v-bind:class="errors.has('name') ? 'is-invalid':''" v-validate="'required'"></b-form-input>
        <label for="" class="mt-2 labels">note *</label>
        <textarea type="text" class="mb-3 form-control" placeholder="Enter Note" v-model="model.note" name="quota" v-bind:class="errors.has('quota') ? 'is-invalid':''" v-validate="'required'" />
        <b-button class="mt-3" variant="secondary" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
        <b-button class="mt-3 float-right" variant="warning" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Update</b-button>
      </form>
    </b-modal>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        apiUrl: {
          worksheetType: window.AppConfig.apiUrl + 'worksheet-type',
        },
        model: {
          uuid: null,
          name: null,
          note: null,
        }
      }
    },
    methods: {
      doSubmit () {
        this.$validator.validateAll().then(res => {
          if (res) {
            if (this.model.uuid !== null) {
              this.$http.patch(this.apiUrl.worksheetType + '/' + this.model.uuid, {
                name: this.model.name,
                note: this.model.note,
              }).then(response => {
                this.$store.dispatch('notification/success', 'Worksheet type has been updated.')
                this.hideModal()
                this.resetData()
                this.$emit('getWorksheetType')
              }).catch(error => {
                this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      resetData () {
        this.model.uuid = null
        this.model.name = null
        this.model.note = null
        this.$validator.reset()
      },
      showModal(row) {
        this.model.uuid = row.uuid
        this.model.name = row.name
        this.model.note = row.note
        this.$validator.reset();
        this.$refs['my-modal'].show()
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      }
    }
  }
</script>